import { Card } from "@/types/v2";
import { Clock } from "lucide-react";
import { getTotalTimeInShop } from "@/lib/cardMetrics";

export interface RoTimeInShopBarProps {
  cardData: Card;
}

export const RoTimeInShopBar = ({ cardData }: RoTimeInShopBarProps) => (
  <div className="flex h-11 shrink-0 items-center justify-center gap-2 rounded-lg bg-slate-900">
    <Clock size={18} className="shrink-0 text-white" />
    <span className="text-sm font-semibold leading-none text-white">
      Total Time in Shop · {getTotalTimeInShop(cardData.history)}
    </span>
  </div>
);
